const STORAGE_KEY = 'goodchat:reply-later-prefs';

export interface ReplyLaterPreferences {
  morningHour: number;
  afternoonHour: number;
  eveningHour: number;
}

const DEFAULTS: ReplyLaterPreferences = {
  morningHour: 8,
  afternoonHour: 13,
  eveningHour: 18,
};

export function getReplyLaterPrefs(): ReplyLaterPreferences {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) return { ...DEFAULTS, ...JSON.parse(raw) };
  } catch {
    // ignore
  }
  return DEFAULTS;
}

export function setReplyLaterPrefs(prefs: Partial<ReplyLaterPreferences>) {
  const current = getReplyLaterPrefs();
  localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...current, ...prefs }));
}

function todayAt(hour: number): Date {
  const d = new Date();
  d.setHours(hour, 0, 0, 0);
  return d;
}

function tomorrowAt(hour: number): Date {
  const d = new Date();
  d.setDate(d.getDate() + 1);
  d.setHours(hour, 0, 0, 0);
  return d;
}

export function formatHour(hour: number): string {
  if (hour === 0) return '12 AM';
  if (hour === 12) return '12 PM';
  return hour < 12 ? `${hour} AM` : `${hour - 12} PM`;
}

export interface SnoozePreset {
  label: string;
  getDate: () => Date;
}

export function getSmartSnoozePresets(): SnoozePreset[] {
  const now = new Date();
  const currentHour = now.getHours();
  const prefs = getReplyLaterPrefs();

  const presets: SnoozePreset[] = [
    { label: 'In 1 hour', getDate: () => new Date(Date.now() + 60 * 60 * 1000) },
  ];

  if (currentHour < 12) {
    // Morning: show afternoon, evening, tomorrow morning
    if (currentHour < prefs.afternoonHour) {
      presets.push({ label: `This afternoon (${formatHour(prefs.afternoonHour)})`, getDate: () => todayAt(prefs.afternoonHour) });
    }
    if (currentHour < prefs.eveningHour) {
      presets.push({ label: `This evening (${formatHour(prefs.eveningHour)})`, getDate: () => todayAt(prefs.eveningHour) });
    }
    presets.push({ label: `Tomorrow morning (${formatHour(prefs.morningHour)})`, getDate: () => tomorrowAt(prefs.morningHour) });
  } else if (currentHour < 18) {
    // Afternoon: show evening, tomorrow morning
    if (currentHour < prefs.eveningHour) {
      presets.push({ label: `This evening (${formatHour(prefs.eveningHour)})`, getDate: () => todayAt(prefs.eveningHour) });
    }
    presets.push({ label: `Tomorrow morning (${formatHour(prefs.morningHour)})`, getDate: () => tomorrowAt(prefs.morningHour) });
  } else {
    // Evening: show tomorrow morning, tomorrow afternoon
    presets.push({ label: `Tomorrow morning (${formatHour(prefs.morningHour)})`, getDate: () => tomorrowAt(prefs.morningHour) });
    presets.push({ label: `Tomorrow afternoon (${formatHour(prefs.afternoonHour)})`, getDate: () => tomorrowAt(prefs.afternoonHour) });
  }

  return presets;
}
